import { createApp } from "vue";
import { createPinia } from "pinia";
import VueClickAway from "vue3-click-away";

import Search from "~/vue/Search.vue";

// Main app
const search = async () => {
	const pinia = createPinia();
	const app = createApp(Search);

	app.use(pinia);
	app.use(VueClickAway);

	return app.mount("#search");
};

// Execute async function
search().then(() => {
	console.log();
});
